routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
     .state('home.procedureDetail', {
       url: __env.routes.procedureDetail,
       template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    })
    .state('home.procedureDetailSlug', {
      url: __env.routes.procedureDetailSlug,
      template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    })
    .state('home.procedureDetailId', {
      url: __env.routes.procedureDetailId,
      template: `<procedure-detail sh-ctrl="shCtrl"></procedure-detail>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/catalog/procedure-detail/procedure-detail.config.js